export const doctorsTableColumn = [
	{
		field: 'DOCTOR NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'STATUS',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 350,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'BUSINESS NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'EMAIL',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 350,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'MOBILE',
		headerClass: 'HeaderBg right-align',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 200,
		flex: 1,
		cellClass: 'right-align',
	},
	{
		field: 'MEDICAL ID',
		headerClass: 'HeaderBg right-align',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 200,
		flex: 1,
		cellClass: 'right-align',
	},
];
export const paymentReceivedColumn = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CUSTOMER NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'PAYMENT MODE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
];
export const creditNoteColumn = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 150,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CREDIT NOTE #',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 250,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CUSTOMER NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'STATUS',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 150,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'TYPE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 300,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 150,
		flex: 1,
		cellClass: 'left-align',
	},
];
export const invoicesSettled = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'INVOICE NO #',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'INVOICE AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'APPLIED AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'BALANCE DUE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
];
export const creditNoteAppliedColumn = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 150,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CREDIT NOTE #',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'APPLIED AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 1,
		cellClass: 'left-align',
	},
];
export const salesReturnColumn = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'SALE RETURN #',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 250,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CUSTOMER NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'STATUS',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'RECEIVED STATUS',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'REFUND MODE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 250,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'AMOUNT',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
];
export const creditNoteTableColumn = [
	{
		field: 'DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CREDIT NOTE #',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 250,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'CUSTOMER NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'STATUS',
		headerClass: 'HeaderBg left-align',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 200,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'TYPE',
		headerClass: 'HeaderBg left-align',
		suppressSizeToFit: true,
		minWidth: 200,
		maxWidth: 300,
		flex: 1,
		cellClass: 'left-align',
	},
	{
		field: 'AMOUNT',
		headerClass: 'HeaderBg left-align',
		suppressSizeToFit: true,
		minWidth: 100,
		maxWidth: 250,
		cellClass: 'left-align',
	},
];
